import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import common.frontend.api.Io
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.jetbrains.skiko.wasm.onWasmReady
import org.w3c.dom.HTMLImageElement
import org.w3c.dom.get
import org.w3c.dom.set
import org.w3c.dom.url.URLSearchParams
import provider.*
import tk.mallumo.log.LOGGER_IS_ENABLED
import ui.ArgsInitial
import ui.LauncherUI
import kotlin.time.Duration.Companion.seconds

private lateinit var display: DisplayProvider

private val externalsProvider by lazy {
    ExternalsProvider()
}

private val localizationProvider by lazy {
    LocalizationProvider.build()
}

private val accountProvider by lazy {
    CommonAccountProvider(
        account = window.localStorage["account"]
            ?.runCatching { CommonAccountProvider.decrypt<Io.User>(window.navigator.userAgent, this) }
            ?.onFailure { it.printStackTrace() }
            ?.getOrNull(),
        credentials = window.localStorage["credentials"]
            ?.runCatching {
                CommonAccountProvider.decrypt<CommonAccountProvider.Credentials>(
                    window.navigator.userAgent,
                    this
                )
            }
            ?.onFailure { it.printStackTrace() }
            ?.getOrNull(),
        onNewUser = { window.localStorage["account"] = CommonAccountProvider.encrypt(window.navigator.userAgent, it) },
        onNewAuth = {
            window.localStorage["credentials"] = CommonAccountProvider.encrypt(window.navigator.userAgent, it)
        },
        onLogout = {
            window.localStorage.removeItem("account")
            window.localStorage.removeItem("credentials")
            window.location.reload()
        }
    )
}

/*
* http://localhost:8080/?cat=DEVICE&sub=REGISTRATION&key=123456B
* https://my.screensoft.org/?cat=DEVICE&sub=REGISTRATION&key=abcdefgh
* https://my.screensoft.org/?cat=DEVICE&sub=REGISTRATION&key=abcdefghi
* https://my.screensoft.org/?cat=DEVICE&sub=REGISTRATION&key=abcdefghij
*
* */
@OptIn(ExperimentalComposeUiApi::class)
suspend fun main() {
    val loader = window.document.getElementById("loader") as? HTMLImageElement
    loader?.style?.display = "block"

    LOGGER_IS_ENABLED = AppBuildConfig.DEBUG
    println(AppBuildConfig.toString())
    display = DisplayProvider(
        Resolution(
            width = window.innerWidth.toFloat(),
            height = window.innerHeight.toFloat(),
            dpi = window.devicePixelRatio.toFloat()
        )
    )

    window.addEventListener("resize", {
        display.onResize(
            Resolution(
                width = window.innerWidth.toFloat(),
                height = window.innerHeight.toFloat(),
                dpi = window.devicePixelRatio.toFloat()
            )
        )
    })
    val params = URLSearchParams(window.location.search)

    val args = ArgsInitial(
        cat = ArgsInitial.Category.get(params.get("cat")).key,
        sub = ArgsInitial.Subcategory.get(params.get("sub")).key,
        key = params.get("key") ?: ""
    )

    if (args.category != ArgsInitial.Category.UNKNOWN) {
        window.history.replaceState(null, "", "/")
    }

    onWasmReady {
        ComposeViewport(viewportContainerId = "application") {
            CompositionLocalProvider(
                LocalDisplayProvider provides display,
                LocalAccountProvider provides accountProvider,
                LocalExternalsProvider provides externalsProvider,
                LocalLocalization provides localizationProvider
            ) { LauncherUI(args) }
            LaunchedEffect(Unit) {
                delay(1.seconds)
                loader?.style?.display = "none"

            }
        }
    }
}
